// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-line-with-icon-line-with-icon__3hhtj {\n  display: flex;\n  flex-direction: row;\n}\n.mongosh-line-with-icon-line-with-icon-icon__2Z08P {\n  display: flex;\n  align-items: center;\n  margin-right: 3px;\n  max-height: 24px;\n}\n.mongosh-line-with-icon-line-with-icon-content__yLCI_ {\n  flex: 1;\n  overflow-x: auto;\n}\n", ""]);
// Exports
exports.locals = {
	"line-with-icon": "mongosh-line-with-icon-line-with-icon__3hhtj",
	"line-with-icon-icon": "mongosh-line-with-icon-line-with-icon-icon__2Z08P",
	"line-with-icon-content": "mongosh-line-with-icon-line-with-icon-content__yLCI_"
};
module.exports = exports;
